import React, { useEffect, useRef, useState } from "react";
import Avatar from "./Avatar";

interface ReplyComposerProps {
  id?: string;
  currentUserName: string;
  currentUserProfilePictureUrl?: string;
  parentAuthor: string;
  onCancel: () => void;
  onSubmit: (value: string) => Promise<void>;
}

const ReplyComposer = ({
  id,
  currentUserName,
  currentUserProfilePictureUrl,
  parentAuthor,
  onCancel,
  onSubmit,
}: ReplyComposerProps) => {
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const submitReply = async () => {
    if (!value.trim() || submitting) return;

    setSubmitting(true);
    await onSubmit(value.trim());
  };

  return (
    <li className="reply is-composer">
      <Avatar
        className="reply-avatar"
        name={currentUserName}
        profilePictureUrl={currentUserProfilePictureUrl}
      />
      <div className="reply-body">
        <div className="reply-composer-meta">
          Replying to <strong>{parentAuthor}</strong>
        </div>
        {id && (
          <label className="sr-only" htmlFor={id}>
            Write your reply
          </label>
        )}
        <textarea
          id={id}
          className="reply-composer-input"
          placeholder="Write your reply..."
          aria-label={id ? undefined : "Write your reply"}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          ref={inputRef}
        />
        <div className="reply-composer-actions">
          <span className="reply-composer-hint">Markdown supported</span>
          <button
            className="reply-composer-cancel"
            type="button"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="reply-composer-submit"
            type="button"
            disabled={!value.trim() || submitting}
            onClick={submitReply}
          >
            {submitting && <span className="reply-submit-spinner" />}
            {submitting ? "Posting..." : "Post reply"}
          </button>
        </div>
      </div>
    </li>
  );
};

export default ReplyComposer;
